import BaseModel from "../../../common/model/base_model";

export default class LoginModel extends BaseModel {

    cluster = '';
    login = '';
    password = '';
    // output parameters
    redirect_url = '';
    require2fa = false;
    second_factor_provider = null;

    constructor(cluster) {
        super();

        if (cluster) {
            this.cluster = cluster;
        }
    }

}